/**
 * view redux reducer
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import {
    CLOSE_MEDIA_OVERLAY, OPEN_MEDIA_OVERLAY, OPEN_PAGE, UPDATE_VIEW_PROPERTY
} from "./consts";


const initialState = {
    currentPage: "",
    mediaOverlayVisible: false,
    mediaOverlayUrl: "",
    mediaOverlayDescription: "",
    adminSection: {},
    controlSection: {}
};


export default function viewReducer(state = initialState, action) {

    switch(action.type) {

        case OPEN_PAGE:

            // TODO: is this the right place for such a side effect?
            document.body.scrollTop = document.documentElement.scrollTop = 0;
    
            return {
                ...state,
                currentPage: action.page
            };

        case OPEN_MEDIA_OVERLAY:

            return {
                ...state,
                mediaOverlayVisible: true,
                mediaOverlayUrl: action.url,
                mediaOverlayDescription: action.description
            };

        case CLOSE_MEDIA_OVERLAY:

            return {
                ...state,
                mediaOverlayVisible: false
            };

        case UPDATE_VIEW_PROPERTY:

            return {
                ...state,
                [action.section]: {
                    ...state[action.section],
                    [action.name]: action.value
                }
            };

        default:
            return state;
    }
}
